module.exports = __webpack_public_path__ + "media/images/mastercard-4545fc0ef0aed77fe63be9d7ad1962e4.png";